import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-collapse/es/index.js
// module id = 250
// module chunks = 0